/**
 * WOM Configuration for Energy Fitness Client
 *
 * Client-specific configuration including:
 * - API endpoints (hardcoded for now)
 * - Theme colors and styling
 * - Enabled widgets
 * - Custom behavior
 */

const DEFAULT_PRODUCT_HANDLE = null; // Will use actual product handle from page

/**
 * Get the current product handle from URL or Shopify globals
 * Returns the actual product handle for API use
 */
function getProductHandle() {
  // Method 1: Shopify Analytics object (most reliable)
  if (
    typeof window.ShopifyAnalytics !== "undefined" &&
    window.ShopifyAnalytics.meta &&
    window.ShopifyAnalytics.meta.product &&
    window.ShopifyAnalytics.meta.product.handle
  ) {
    return window.ShopifyAnalytics.meta.product.handle;
  }

  // Method 2: Extract from Shopify product URL structure
  const urlMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
  if (urlMatch && urlMatch[1]) {
    return urlMatch[1];
  }

  // Method 3: Meta tags
  const metaUrl = document.querySelector('meta[property="og:url"]');
  if (metaUrl && metaUrl.content) {
    const metaMatch = metaUrl.content.match(/\/products\/([^\/\?]+)/);
    if (metaMatch && metaMatch[1]) {
      return metaMatch[1];
    }
  }

  console.warn("WOM Config: Unable to resolve product handle from page.");
  // Return null - let the calling code handle the fallback
  return null;
}

const vesselsWOMConfig = {
  name: "Energy Fitness",

  // API Configuration
  apiBaseUrl: "https://api.thewordofmouth.in",
  companyId: "energyfitness", // Store slug used by new v2 API

  // getProductHandle returns product handle for API use
  getProductHandle: getProductHandle,

  // Dynamic API URL - Constructs URL from current product handle
  get reviewsApiUrl() {
    // Return null to let wom-core.js construct URL dynamically from companyId and productHandle
    // This ensures each product uses its own handle instead of hardcoded one
    return null;
  },

  // Dynamic API URL - Constructs URL from current product handle
  get detailedReviewsApiUrl() {
    // Return null to let wom-core.js construct URL dynamically from companyId and productHandle
    // This ensures each product uses its own handle instead of hardcoded one
    return null;
  },

  // Use local JSON data instead of API (set to false to use API)
  useLocalData: false, // Use live API instead of dummy data
  localDataUrl: "/assets/wom-product-data.json", // Fallback path to local JSON file

  // Debug mode
  debug: true,

  // Theme Colors - Customize for Energy Fitness
  colors: {
    primary: "#1a1a1a",
    accent: "#C42D2C",
    background: "#ffffff",
    text: "#374151",
    textLight: "#6b7280",
    border: "#e5e7eb",
    success: "#10b981",
    starColor: "#C70100", // Stars with red color (matching social proof)
  },

  // Typography
  fontFamily:
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",

  // Spacing and Layout
  spacing: {
    cardRadius: "12px",
    cardPadding: "20px",
    gap: "16px",
  },

  // Widget Configuration - Enable/Disable widgets
  components: {
    socialProof: true, // Shows rating and review count
    liveUsers: true, // Shows "X people viewing now"
    ratingBreakdown: true, // Shows star rating distribution
    reviews: true, // Shows full review cards
  },

  // Override to use company-wide data instead of product-specific
  useCompanyWideData: false,

  // Widget Settings
  settings: {
    liveUpdates: true, // Auto-refresh live data
    showVerifiedBadge: true, // Show verified purchase badges
    reviewsPerPage: 3, // Number of reviews to show per page
  },

  // Custom Callbacks (Optional)
  onWriteReview: function () {
    // Custom logic when "Write Review" is clicked
    console.log("Opening write review modal");
  },

  onLoadMore: function () {
    // Custom logic when "Load More" is clicked
    console.log("Loading more reviews");
  },
};

// Export for use
if (typeof module !== "undefined" && module.exports) {
  module.exports = vesselsWOMConfig;
} else {
  // Expose to window with both names for backward compatibility
  window.vesselsWOMConfig = vesselsWOMConfig; // Primary
  window.clientWOMConfig = vesselsWOMConfig; // Alias for backward compatibility
}

